<template>
  <div class="dev-table-list">
    <template v-if="type === 'dev' || (type==='rec')">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        :row-class-name="rowClassName"
        :expanded-row-keys="expandedRowKeys"
        :custom-header-row="expandAllHandler"
        @expandedRowsChange="expandHandler"
        @change="handleChange"
      >
        <span
          slot="rank"
          slot-scope="text"
          :class="{rankTop: text*1 < 4}"
        >
          {{ text }}
        </span>
        <div
          slot="filterDropdown"
          slot-scope="{}"
          class="custom-filter-dropdown"
        >
          <a-popover
            :visible="isTablePShow"
            placement="bottomLeft"
            overlay-class-name="popover-filter"
          >
            <template slot="content">
              <div class="drop-down-box">
                <filter-cascader-form
                  :type="type"
                  @filterFromHandler="filterFromHandler"
                />
              </div>
            </template>
            <!-- <span class="from-info-btn-pop">test</span> -->
          </a-popover>
        </div>
        <div
          slot="filterDropdownName"
          slot-scope="{}"
          class="table-custom-filter-dropdown"
        >
          <div v-if="singleFilter.length > 0" class="drop-down-box">
            <a
              v-for="item in singleFilter"
              :key="item.value"
              href="javascript:;"
              :class="{'filter-active' : filtersparams.groupType === item.value }"
              @click="filterHandle(item)"
            >
              {{ item.text }}
            </a>
          </div>
        </div>
        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          :columns="columns"
          :data-source="record.childTableData"
          :pagination="false"
          :show-header="true"
          class="inner-table"
          :class="[{'data-time-table': !Object.keys(record).includes('rank')}, {'isEnglish-table':$isEnglish }]"
        />
      </a-table>
    </template>
    <template v-else>
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="false"
        row-key="name"
        :custom-header-row="expandAllHandler"
        @change="handleChange"
      >
        <div

          slot="filterDropdownName"
          slot-scope="{}"
          class="table-custom-filter-dropdown"
        >
          <div v-if="singleFilter.length > 0" class="drop-down-box">
            <a
              v-for="item in singleFilter"
              :key="item.value"
              href="javascript:;"
              :class="{'filter-active' : filtersparams.groupType === item.value }"
              @click="filterHandle(item)"
            >
              {{ item.text }}
            </a>
          </div>
        </div>
      </a-table>
    </template>
    <Pagination
      v-if="pagination&&tableData.length"
      :pagination="pagesData"
      @change="handlePageChange"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Pagination from '@/components/pc/Pagination'
import FilterCascaderForm from './FilterCascaderForm'
export default {
  components: {
    Pagination,
    FilterCascaderForm
  },
  props: {
    tableData: {
      type: Array,
      default: () => ([])
    },
    columns: {
      type: Array,
      default: () => ([])
    },
    tableConfigOptions: {
      type: Array,
      default: () => ([])
    },
    type: {
      type: String,
      default: ''
    },
    time: {
      type: Object,
      default: () => ({})
    },
    pagination: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultTableRole: '',
      pagesData: { total: 0, currentPage: 1, pageSize: 10, pageSizes: [10, 20, 30, 50] },
      innerData: [],
      isPopoverShow: true,
      expandedRowKeys: [],
      filtersparams: {},
      singleFilter: []
    }
  },
  computed: {
    ...mapState('statistic', ['detailTableDatas', 'recTablesDetailDatas', 'followTablesDetailDatas', 'isTablePShow', 'receptionType', 'rowKeysReady']),
    rowKeys () {
      let rowDataKeys = []
      this.tableData.forEach(item => {
        if (item.childTableData && item.childTableData.length > 0) {
          rowDataKeys.push(item.key)
        }
      })
      return rowDataKeys
    }
    // rowKeys: {
    //   set (val) {
    //     this.setRowKeysArr(val)
    //   },
    //   get () {
    //     return this.rowKeysArr
    //   }
    // }
  },
  watch: {
    rowKeysArr (val) {
      if (val && this.rowKeysReady) {
        setTimeout(() => {
          this.expandedRowKeys = val
        })
      }
    },
    detailTableDatas: {
      handler (val) {
        if (!val) return
        if (val.count) {
          this.pagesData.total = val.count
          this.pagesData.currentPage = val.currentPage
          this.pagesData.pageSize = val.curpagesize
        }
        // this.fetchGetFromCascaderDatas({ scope: 'all', type: 0 })
        if (this.type === 'dev' && val.config) {
          val.config.forEach(item => {
            if (item.sortId === 'fromtype') {
              this.setFromDatas(item.options)
            }
          })
        }
        setTimeout(() => {
          this.expandedRowKeys = this.rowKeys
        })
      },
      deep: true
    },
    recTablesDetailDatas (val) {
      if (!val) return
      if (val.count) {
        this.pagesData.total = val.count
        this.pagesData.currentPage = val.currentPage
        this.pagesData.pageSize = val.curpagesize
      }
      if (this.type === 'rec' && val.config) {
        val.config.forEach(item => {
          if (item.sortId === 'rectype') {
            this.setFromDatas(item.options)
          }
        })
      }
      setTimeout(() => {
        this.expandedRowKeys = this.rowKeys
      })
    },
    followTablesDetailDatas (val) {
      if (!val) return
      if (val.count) {
        this.pagesData.total = val.count
        this.pagesData.currentPage = val.currentPage
        this.pagesData.pageSize = val.curpagesize
      }
    }
  },
  methods: {
    ...mapActions('statistic', ['fetchGetDetailTableDatas', 'fetchGetRecDetailTableDatas', 'fetchGetFollowDetailTableDatas']),
    ...mapMutations('statistic', ['setFromDatas']),
    handleChange (pagination, filters, sorter) {
      if (sorter.order) {
        let sort = (sorter.order === 'ascend' ? 1 : 2)
        this.filtersparams = { ...this.filtersparams, ...this.time, page: this.pagesData.currentPage, pagesize: this.pagesData.pageSize, sorttype: sort, sortId: sorter.field }
      }
      // if (filters.name) {
      //   this.filtersparams = { ...this.filtersparams, ...this.time, page: this.pagesData.currentPage, pagesize: this.pagesData.pageSize, groupType: filters.name[0] }
      // }
      if (this.type === 'dev') {
        this.fetchGetDetailTableDatas(this.filtersparams)
      } else if (this.type === 'rec') {
        this.fetchGetRecDetailTableDatas(this.filtersparams)
      } else if (this.type === 'follow') {
        this.fetchGetFollowDetailTableDatas(this.filtersparams)
      }
      this.$emit('changeParams', this.filtersparams)
    },
    handlePageChange (val) {
      const params = { ...this.time, page: val.currentPage, pagesize: val.pageSize }
      if (this.type === 'dev') {
        this.fetchGetDetailTableDatas(params)
      } else if (this.type === 'rec') {
        this.fetchGetRecDetailTableDatas(params)
      } else if (this.type === 'follow') {
        this.fetchGetFollowDetailTableDatas(params)
      }
      this.$emit('changeParams', { page: val.currentPage, pagesize: val.pageSize })
    },
    formateTableConfigOptions (data) {
      const tempv = []
      data.map(value => {
        const [values, key] = value
        tempv.push({
          key: values,
          value: key
        })
      })
      return tempv
    },
    closePopver () {
      this.isPopoverShow = false
    },
    // 设置没有子表格数据的class
    rowClassName (record, index) {
      const childtableDataArray = record.childTableData
      if (!childtableDataArray || (childtableDataArray && childtableDataArray.length <= 0)) {
        let classes = 'no-child-table'
        if (this.tableData.length - 1 === index) {
          if (this.type === 'rec' && !Object.keys(record).includes('rectype') && Object.keys(record).includes('rank') && this.receptionType === 'createSta') {
            classes = 'no-child-table'
          } else {
            classes = 'no-child-table total-tr-row'
          }
        } else {
          classes = 'no-child-table'
        }
        return classes
      }
    },
    expandHandler (pros) {
      this.expandedRowKeys = pros
    },
    // 控制表格数据全部展示或者隐藏
    expandAllHandler (columns, record) {
      if (columns[0].key === 'rc-table-expand-icon-cell') {
        columns[0].customHeaderCell = (record) => {
          return {
            // attrs: {
            //   id: 'foo'
            // },
            domProps: {
              innerHTML: `<span class="all-show-hide-icon ant-table-row-expand-icon ${this.rowKeys.length === 0 ? 'no-row-keys-expand' : ''} ${this.expandedRowKeys.length <= 0 ? 'ant-table-row-collapsed' : 'ant-table-row-expanded'}"></span>`
            },
            on: {
              click: (e) => {
                const classes = e.srcElement.className
                this.expandedRowKeys = classes.indexOf('ant-table-row-collapsed') > -1 ? this.rowKeys : []
              } // 点击表头行
            }
          }
        }
      }
      columns.forEach(item => {
        if (item.key === 'fromtype' || item.key === 'rectype' || item.key === 'name') {
          const arr = item.key !== 'name' ? this.filtersparams[item.key] : this.filtersparams['groupType']
          const isArr = arr && Array.isArray(arr) && arr.length > 0
          const isObj = !Array.isArray(arr) && arr && Object.keys(arr).length > 0
          let isNoFilter = false

          if (item.key === 'name') {
            this.singleFilter = item.options.length > 0 ? item.options : []
            isNoFilter = item.options.length === 0
          }
          // const isNoFilter = item.key === 'name' && (this.singleFilter.length === 0)
          // console.log(this.singleFilter)
          item.customHeaderCell = (record) => {
            return {
              attrs: {
                id: item.key,
                'class': `ant-table-column-has-actions ant-table-column-has-filters ${(isArr || isObj) ? 'filter-th-selected' : ''} ${isNoFilter ? 'no-filter-icon' : ''}`
              }
            }
          }
        } else if (item.key === 'name') {
        }
      })
    },
    filterFromHandler (values) {
      this.filtersparams = { ...this.filtersparams, ...this.time, ...values, page: this.pagesData.currentPage, pagesize: this.pagesData.pageSize }
      if (this.type === 'dev') {
        this.fetchGetDetailTableDatas(this.filtersparams)
      } else if (this.type === 'rec') {
        this.fetchGetRecDetailTableDatas(this.filtersparams)
      }
      this.$emit('changeParams', this.filtersparams)
    },
    filterHandle  (item) {
      document.getElementById('name').querySelector(`.anticon-filter`).click()
      this.filtersparams = { ...this.filtersparams, ...this.time, page: this.pagesData.currentPage, pagesize: this.pagesData.pageSize, groupType: item.value }
      if (this.type === 'dev') {
        this.fetchGetDetailTableDatas(this.filtersparams)
      } else if (this.type === 'rec') {
        this.fetchGetRecDetailTableDatas(this.filtersparams)
      } else if (this.type === 'follow') {
        this.fetchGetFollowDetailTableDatas(this.filtersparams)
      }
      this.$emit('changeParams', this.filtersparams)
    }
  }
}
</script>
<style lang="scss" scoped>
.dev-table-list::v-deep {
  .rankTop {
    color: #42C27E !important;
  }
  .filter-th-selected {
    .anticon-filter {
      color: #5077aa;
    }
  }
  .no-filter-icon {
    .anticon-filter {
      display: none;
    }
  }
  .ant-table-row-expand-icon {
    background: #4CA0F2;
    border-radius: 2px;
    border: 0 none;
    color: #fff;
    font-size: 16px;
  }
  .total-tr-row > td, .total-tr-row > td span{
    font-weight: bold !important;
  }
  .custom-filter-dropdown {
    margin: 10px 0 0  -89px;
  }
  .ant-table-expanded-row > td:nth-child(1){
    // display: none;
  }
  .no-child-table .ant-table-row-expand-icon, .no-row-keys-expand {
    display: none !important;
  }
  tr.ant-table-expanded-row td > .ant-table-wrapper {
    margin: 0;
  }
  tr.ant-table-expanded-row, tr.ant-table-expanded-row:hover {
    background: #f5f6f7;
  }
  .ant-table-expanded-row > td:nth-child(2) {
    // display: none;
    .ant-table-thead{
      display: none;
    }
    padding: 0;
    .inner-table{
      margin-left: -50px;
      td:nth-child(1), th:nth-child(1){
       width: 110px;
      }
      td{
        word-break: break-all;
        color: #666;
      }
      tr:last-child td{
        border-bottom: none!important;
      }

    }
    .isEnglish-table {
      margin-left: -22px;
    }
    .data-time-table {
        margin-left: 0;
    }
  }
}
</style>
<style lang="scss">
  .popover-filter {
    padding-top: 0;
    .ant-popover-arrow {
      display: none;
    }
    .ant-popover-inner-content {
      padding: 24px 0 0;
    }
    .ant-popover-inner {
      position: relative;
    }
  }
</style>
